<ion-content>
  <div class="container">
    <h1>Geen toegang</h1>
    <p>Je hebt geen toegang tot het Alfred Dashboard.</p>
    <ion-button (click)="logout()">Uitloggen</ion-button>
  </div>
</ion-content>
